import React from "react";
import classNames from "classnames";

import AdaptiveTooltip from "../../AdaptiveTooltip";

import Language from "../../language/language";
import "../stylesheets/kvItem.scss";

function KvItem(props) {
  const { vskey, value, className } = props;
  return (
    <div className={classNames("kvItem", className)}>
      <Language resource={vskey} className="kvItem__key" />
      <AdaptiveTooltip className="kvItem__value" title={value}>
        {` : ${value}`}
      </AdaptiveTooltip>
    </div>
  );
}

export default KvItem;



// WEBPACK FOOTER //
// ./src/components/common/teamInfo/kvItem.js